/**
 * Programas educativos vigentes de la UNACH
 * Datos extraídos de supabase/programas_vigentes.json
 * Archivo generado automáticamente - No editar manualmente
 */

export interface UnidadAcademica {
  nombreUnidad: string;
  municipio: string;
  programas: string[];
}

export const programasVigentes: UnidadAcademica[] = [
  {
    nombreUnidad: 'CENTRO DE ESTUDIOS PARA EL ARTE Y LA CULTURA, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN DANZA'],
  },
  {
    nombreUnidad:
      'CENTRO DE ESTUDIOS PARA EL DESARROLLO MUNICIPAL Y POLITICAS PUBLICAS, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: [
      'LICENCIATURA EN DESARROLLO MUNICIPAL Y GOBERNABILIDAD',
      'LICENCIATURA EN ESTADÍSTICA Y SISTEMAS DE INFORMACIÓN',
      'LICENCIATURA EN GERENCIA SOCIAL',
    ],
  },
  {
    nombreUnidad:
      'CENTRO DE ESTUDIOS PARA LA CONSTRUCCION DE CIUDADANIA Y LA SEGURIDAD, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN DERECHOS HUMANOS'],
  },
  {
    nombreUnidad: 'CENTRO DE ESTUDIOS SOBRE LA UNIVERSIDAD, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN SEGURIDAD DE POBLACIONES HUMANAS ANTE DESASTRES'],
  },
  {
    nombreUnidad: 'CENTRO UNIVERSIDAD EMPRESA, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN GESTIÓN DE LA MICRO, PEQUEÑA Y MEDIANA EMPRESA'],
  },
  {
    nombreUnidad: 'COORDINACION DE LA LICENCIATURA EN CAFICULTURA, ANGEL ALBINO CORZO',
    municipio: 'ANGEL ALBINO CORZO',
    programas: ['LICENCIATURA EN CAFICULTURA'],
  },
  {
    nombreUnidad:
      'COORDINACION DE LA LICENCIATURA EN INGENIERIA EN SISTEMAS COSTEROS, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA DE INGENIERO EN SISTEMAS COSTEROS'],
  },
  {
    nombreUnidad: 'ESCUELA DE CIENCIAS ADMINISTRATIVAS ISTMO-COSTA, CAMPUS IX, TONALÁ',
    municipio: 'TONALÁ',
    programas: [
      'LICENCIATURA EN ADMINISTRACIÓN',
      'LICENCIATURA EN COMERCIO INTERNACIONAL',
      'LICENCIATURA EN CONTADURÍA',
      'LICENCIATURA EN GESTIÓN TURÍSTICA',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE CIENCIAS ADMINISTRATIVAS, CAMPUS IX, ARRIAGA',
    municipio: 'ARRIAGA',
    programas: [
      'LICENCIATURA EN ADMINISTRACIÓN',
      'LICENCIATURA EN COMERCIO INTERNACIONAL',
      'LICENCIATURA EN CONTADURÍA',
      'LICENCIATURA EN GESTIÓN TURÍSTICA',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE CIENCIAS QUIMICAS, OCOZOCOAUTLA DE ESPINOSA',
    municipio: 'OCOZOCOAUTLA DE ESPINOSA',
    programas: ['LICENCIATURA EN QUÍMICO FARMACOBIÓLOGO'],
  },
  {
    nombreUnidad:
      'ESCUELA DE CIENCIAS Y PROCESOS AGROPECUARIOS INDUSTRIALES, ISTMO-COSTA, CAMPUS IX, ARRIAGA',
    municipio: 'ARRIAGA',
    programas: [
      'LICENCIATURA DE INGENIERO AGROINDUSTRIAL',
      'LICENCIATURA EN INGENIERÍA AGROINDUSTRIAL',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE CONTADURÍA Y ADMINISTRACIÓN, CAMPUS VII, PICHUCALCO',
    municipio: 'PICHUCALCO',
    programas: [
      'LICENCIATURA EN ADMINISTRACIÓN',
      'LICENCIATURA EN AGRONEGOCIOS',
      'LICENCIATURA EN COMERCIO INTERNACIONAL',
      'LICENCIATURA EN CONTADURÍA',
      'LICENCIATURA EN GESTIÓN TURÍSTICA',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE ESTUDIOS AGROPECUARIOS MEZCALAPA, COPAINALA',
    municipio: 'COPAINALA',
    programas: [
      'LICENCIATURA EN INGENIERO AGRÓNOMO',
      'LICENCIATURA EN INGENIERÍA EN AGRONOMÍA',
      'LICENCIATURA EN MEDICINA VETERINARIA Y ZOOTECNIA',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE GESTIÓN Y AUTODESARROLLO INDÍGENA, SAN CRISTÓBAL DE LAS CASAS',
    municipio: 'SAN CRISTÓBAL DE LAS CASAS',
    programas: [
      'LICENCIATURA EN GESTIÓN PARA EL DESARROLLO Y LA DIVERSIDAD',
      'LICENCIATURA EN GESTIÓN Y AUTODESARROLLO INDÍGENA',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE HUMANIDADES, CAMPUS IV, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN PEDAGOGÍA'],
  },
  {
    nombreUnidad: 'ESCUELA DE HUMANIDADES, CAMPUS IX, PIJIJIAPAN',
    municipio: 'PIJIJIAPAN',
    programas: ['LICENCIATURA EN PEDAGOGÍA', 'LICENCIATURA EN PUERICULTURA Y DESARROLLO INFANTIL'],
  },
  {
    nombreUnidad: 'ESCUELA DE HUMANIDADES, CAMPUS IX, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN PEDAGOGÍA'],
  },
  {
    nombreUnidad:
      'ESCUELA DE LENGUAS, CAMPUS SAN CRISTÓBAL DE LAS CASAS, SAN CRISTÓBAL DE LAS CASAS',
    municipio: 'SAN CRISTÓBAL DE LAS CASAS',
    programas: [
      'LICENCIATURA EN LA ENSEÑANZA DEL FRANCÉS',
      'LICENCIATURA EN LA ENSEÑANZA DEL INGLÉS',
    ],
  },
  {
    nombreUnidad: 'ESCUELA DE LENGUAS, CAMPUS TAPACHULA, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN INGLÉS', 'LICENCIATURA EN LA ENSEÑANZA DEL INGLÉS'],
  },
  {
    nombreUnidad: 'ESCUELA DE SISTEMAS ALIMENTARIOS, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN SEGURIDAD ALIMENTARIA'],
  },
  {
    nombreUnidad: 'FACULTAD DE ARQUITECTURA, CAMPUS I, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN ARQUITECTURA'],
  },
  {
    nombreUnidad: 'FACULTAD DE CIENCIAS ADMINISTRATIVAS, CAMPUS VIII, COMITÁN DE DOMÍNGUEZ',
    municipio: 'COMITÁN DE DOMÍNGUEZ',
    programas: [
      'LICENCIATURA EN ADMINISTRACIÓN',
      'LICENCIATURA EN COMERCIO INTERNACIONAL',
      'LICENCIATURA EN CONTADURÍA',
      'LICENCIATURA EN GESTIÓN TURÍSTICA',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE CIENCIAS AGRÍCOLAS, CAMPUS IV, HUEHUETÁN',
    municipio: 'HUEHUETÁN',
    programas: [
      'LICENCIATURA EN INGENIERO AGRÓNOMO',
      'LICENCIATURA EN INGENIERO FORESTAL',
      'LICENCIATURA EN INGENIERÍA FORESTAL',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE CIENCIAS AGRONÓMICAS, CAMPUS V, VILLAFLORES',
    municipio: 'VILLAFLORES',
    programas: [
      'LICENCIATURA EN GESTIÓN EN CADENAS PRODUCTIVAS',
      'LICENCIATURA EN INGENIERO AGRÓNOMO',
      'LICENCIATURA EN INGENIERO AGRÓNOMO EN GANADERÍA AMBIENTAL',
      'LICENCIATURA EN INGENIERO EN DESARROLLO AGROAMBIENTAL',
    ],
  },
  {
    nombreUnidad:
      'FACULTAD DE CIENCIAS DE LA ADMINISTRACIÓN, CAMPUS IV, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: [
      'LICENCIATURA EN ADMINISTRACIÓN',
      'LICENCIATURA EN AGRONEGOCIOS',
      'LICENCIATURA EN COMERCIO INTERNACIONAL',
      'LICENCIATURA EN GESTIÓN TURÍSTICA',
    ],
  },
  {
    nombreUnidad:
      'FACULTAD DE CIENCIAS DE LA ADMINISTRACION, CAMPUS IV EXTENSION CATAZAJA, COPAINALA',
    municipio: 'COPAINALA',
    programas: ['LICENCIATURA EN AGRONEGOCIOS'],
  },
  {
    nombreUnidad: 'FACULTAD DE CIENCIAS EN FÍSICA Y MATEMÁTICAS, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: [
      'LICENCIATURA EN FÍSICA',
      'LICENCIATURA EN INGENIERÍA FÍSICA',
      'LICENCIATURA EN MATEMÁTICAS',
      'LICENCIATURA EN MATEMÁTICAS APLICADAS',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE CIENCIAS QUÍMICAS, CAMPUS IV, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN CRIMINALISTICA', 'LICENCIATURA EN QUÍMICO FARMACOBIÓLOGO'],
  },
  {
    nombreUnidad:
      'FACULTAD DE CIENCIAS QUÍMICAS, EXTENSION CIV, OCOZOCOAUTLA, OCOZOCOAUTLA DE ESPINOSA',
    municipio: 'OCOZOCOAUTLA DE ESPINOSA',
    programas: ['LICENCIATURA EN QUÍMICO FARMACOBIÓLOGO'],
  },
  {
    nombreUnidad: 'FACULTAD DE CIENCIAS SOCIALES, CAMPUS III, SAN CRISTÓBAL DE LAS CASAS',
    municipio: 'SAN CRISTÓBAL DE LAS CASAS',
    programas: [
      'LICENCIATURA EN ANTROPOLOGÍA SOCIAL',
      'LICENCIATURA EN ECONOMÍA',
      'LICENCIATURA EN HISTORIA',
      'LICENCIATURA EN SOCIOLOGÍA',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE CONTADURÍA Y ADMINISTRACIÓN, CAMPUS I, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: [
      'LICENCIATURA EN ADMINISTRACIÓN',
      'LICENCIATURA EN CONTADURÍA',
      'LICENCIATURA EN GESTIÓN TURÍSTICA',
      'LICENCIATURA EN INGENIERÍA EN DESARROLLO Y TECNOLOGÍAS DE SOFTWARE',
      'LICENCIATURA EN SISTEMAS COMPUTACIONALES',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE DERECHO, CAMPUS III, SAN CRISTÓBAL DE LAS CASAS',
    municipio: 'SAN CRISTÓBAL DE LAS CASAS',
    programas: [
      'LICENCIATURA EN DERECHO',
      'LICENCIATURA EN DERECHO CON FORMACIÓN EN IMPARTICIÓN DE JUSTICIA FEDERAL',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE DERECHO, CAMPUS III EXTENSION PALENQUE, PALENQUE',
    municipio: 'PALENQUE',
    programas: ['LICENCIATURA EN DERECHO'],
  },
  {
    nombreUnidad:
      'FACULTAD DE DERECHO, CAMPUS III EXTENSION TAPACHULA, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN DERECHO'],
  },
  {
    nombreUnidad: 'FACULTAD DE HUMANIDADES, CAMPUS VI, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: [
      'LICENCIATURA EN BIBLIOTECOLOGÍA Y GESTIÓN DE INFORMACIÓN',
      'LICENCIATURA EN COMUNICACIÓN',
      'LICENCIATURA EN FILOSOFÍA',
      'LICENCIATURA EN LENGUA Y LITERATURA HISPANOAMERICANAS',
      'LICENCIATURA EN PEDAGOGÍA',
      'LICENCIATURA EN TECNOLOGÍAS DE INFORMACIÓN Y COMUNICACIÓN APLICADAS A LA EDUCACIÓN',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE INGENIERÍA, CAMPUS I, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: [
      'LICENCIATURA EN INGENIERÍA CIVIL',
      'LICENCIATURA EN INGENIERÍA EN CIENCIAS DE LOS MATERIALES',
      'LICENCIATURA EN INGENIERÍA HIDRÁULICA',
    ],
  },
  {
    nombreUnidad: 'FACULTAD DE LENGUAS, CAMPUS TUXTLA, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: [
      'LICENCIATURA EN LA ENSEÑANZA DEL FRANCÉS',
      'LICENCIATURA EN LA ENSEÑANZA DEL INGLÉS',
    ],
  },
  {
    nombreUnidad:
      'FACULTAD DE MEDICINA HUMANA "DR. MANUEL VELASCO SUÁREZ", CAMPUS II, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN GERONTOLOGÍA', 'LICENCIATURA EN MÉDICO CIRUJANO'],
  },
  {
    nombreUnidad:
      'FACULTAD DE MEDICINA HUMANA "DR. MANUEL VELASCO SUAREZ", CAMPUS IV, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN MÉDICO CIRUJANO'],
  },
  {
    nombreUnidad: 'FACULTAD DE MEDICINA HUMANA EXTENSION TAPACHULA, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN MÉDICO CIRUJANO'],
  },
  {
    nombreUnidad: 'FACULTAD DE MEDICINA VETERINARIA Y ZOOTECNIA, CAMPUS II, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN MEDICINA VETERINARIA Y ZOOTECNIA'],
  },
  {
    nombreUnidad:
      'FACULTAD DE MEDICINA VETERINARIA Y ZOOTECNIA C II, EXTENSION PICHUCALCO, PICHUCALCO',
    municipio: 'PICHUCALCO',
    programas: ['LICENCIATURA EN MEDICINA VETERINARIA Y ZOOTECNIA'],
  },
  {
    nombreUnidad: 'FACULTAD MAYA DE ESTUDIOS AGROPECUARIOS, CATAZAJA',
    municipio: 'CATAZAJA',
    programas: [
      'LICENCIATURA EN INGENIERÍA AGROINDUSTRIAL',
      'LICENCIATURA EN INGENIERÍA EN AGRONOMÍA',
      'LICENCIATURA EN INGENIERÍA EN DESARROLLO RURAL',
      'LICENCIATURA EN INGENIERÍA EN PROCESOS AGROINDUSTRIALES',
      'LICENCIATURA EN INGENIERÍA EN SISTEMAS FORESTALES',
      'LICENCIATURA EN INGENIERÍA FORESTAL',
      'LICENCIATURA EN INGENIERO AGRÓNOMO',
      'LICENCIATURA EN MEDICINA VETERINARIA Y ZOOTECNIA',
      'LICENCIATURA EN SEGURIDAD ALIMENTARIA',
    ],
  },
  {
    nombreUnidad:
      'FACULTAD MAYA DE ESTUDIOS AGROPECUARIOS, EXTENSION TAPACHULA, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: ['LICENCIATURA EN SEGURIDAD ALIMENTARIA'],
  },
  {
    nombreUnidad: 'INSTITUTO DE BIOCIENCIAS, TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    municipio: 'TAPACHULA DE CÓRDOVA Y ORDÓÑEZ',
    programas: [
      'LICENCIATURA DE INGENIERO EN SISTEMAS COSTEROS',
      'LICENCIATURA EN INGENIERO BIOTECNÓLOGO',
    ],
  },
  {
    nombreUnidad: 'INSTITUTO DE INVESTIGACIONES JURIDICAS, TUXTLA GUTIÉRREZ',
    municipio: 'TUXTLA GUTIÉRREZ',
    programas: ['LICENCIATURA EN DERECHO'],
  },
];

/**
 * Obtiene una lista plana de todos los programas únicos
 */
export function getAllProgramas(): { value: string; label: string; unidad: string }[] {
  const programasMap = new Map<string, { value: string; label: string; unidad: string }>();

  for (const unidad of programasVigentes) {
    for (const programa of unidad.programas) {
      if (!programasMap.has(programa)) {
        programasMap.set(programa, {
          value: programa,
          label: programa,
          unidad: unidad.nombreUnidad,
        });
      }
    }
  }

  return Array.from(programasMap.values()).sort((a, b) => a.label.localeCompare(b.label, 'es'));
}

/**
 * Obtiene los programas agrupados por unidad académica
 */
export function getProgramasPorUnidad(): { unidad: string; programas: string[] }[] {
  return programasVigentes
    .map((unidad) => ({
      unidad: unidad.nombreUnidad,
      programas: [...unidad.programas].sort((a, b) => a.localeCompare(b, 'es')),
    }))
    .sort((a, b) => a.unidad.localeCompare(b.unidad, 'es'));
}

/**
 * Obtiene la lista de municipios únicos
 */
export function getMunicipios(): string[] {
  const municipios = new Set<string>();
  for (const unidad of programasVigentes) {
    municipios.add(unidad.municipio);
  }
  return Array.from(municipios).sort((a, b) => a.localeCompare(b, 'es'));
}
